import { inject, Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { map, Observable } from "rxjs";
import { LoginResponse, SharedLoginRepository, UserStore } from "@shared/src/public-api";

@Injectable({
	providedIn: "root"
})
export class AuthGuard implements CanActivate {
	userStore = inject(UserStore);
	loginRepository = inject(SharedLoginRepository);
	router = inject(Router);

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (this.userStore.isLoggedIn()) {
			return true;
		} else {
			const jwt: string | null = localStorage.getItem("access_token");
			if (jwt) {
				return this.loginRepository.getUser(jwt).pipe(
					map((userLogin: LoginResponse) => {
						if (userLogin.jwt) {
							return true;
						} else {
							localStorage.removeItem("access_token");
							return this.router.parseUrl("/login");
						}
					})
				);
			} else {
				localStorage.removeItem("access_token");
				return this.router.parseUrl("/login");
			}
		}
	}
}
